import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideNavigationService } from 'src/app/core/services/navigation-service/side-navigation.service';
import { ButtonTypeEnum } from '../../../enums/buttonType.enum';
import { CurrentNavigationItemService } from '../../../services/navigation-service/current-navigation-item.service';
import { PlatformService } from '../../../services/platform-service/platform.service';
import { ReleaseVersionLinkComponent } from '../release-version-link/release-version-link.component';

@Component({
  selector: 'navigate-footer',
  templateUrl: './footer-navigation.component.html',
  styleUrls: ['./footer-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, ReleaseVersionLinkComponent],
})
export class FooterNavigationComponent {
  constructor(
    protected sideNavigationService: SideNavigationService,
    protected currentNavigationItemService: CurrentNavigationItemService,
    protected platformService: PlatformService,
  ) {}

  protected readonly ButtonTypeEnum = ButtonTypeEnum;
  protected year = new Date().getFullYear();
}
